import React from "react";
import { Route, Redirect } from "react-router-dom";
import utils from "../utils/utils";

function PrivateRoute(com: any) {
    let { component: Component, authed, path, ...rest } = com;
    //检查验证
    const checkLogin = () => {
        // H5跳转小程序，返回到原H5页面(带参数），进入该页面，无需二次登录。
        // 该功能是map组件，定位选点，返回到H5，登录状态保持
        if(path ==='/visitForm' && !sessionStorage.getItem('token')){
           sessionStorage.setItem("token", localStorage.getItem('token') || "");
        }
        const token = sessionStorage.getItem('token');
    
        if (token) {
            return true;
        }
        else {
            return false;
        }
    }

    const isCheckLogin = checkLogin();

    return (
        <Route
            {...rest}
            render={(props) => isCheckLogin === true
                ? <Component {...props} />
                : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            }
        />
    )
}


export default PrivateRoute;